module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"LogoutButton":{"text":"Odhlásit"}}}')
  delete Component.options._Ctor
}
